import { LogErrors } from './../LogErrors'

import { UpdateCenterUserFirstTime as DLUpdateCenterUserFirstTime } from './../DL/Users'


/**
 * Marca el primer ingreso del usuario al centro con el perfil indicado. Es un registro
 * interno silencioso: no bloquea ni informa al usuario, solo se registra si falla.
 *
 * @param {number} idCenter
 * @param {number} idUserRol - 1 Ztudiante, 2 Instructor, 3 Líder (EL/Roles.js)
 */
const MarkFirstTimeEntry = async (idCenter, idUserRol) => {
    try {
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' }
        }

        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const token = userData?.token
        if (!token) {
            return { success: false, message: '' }
        }

        if (!idCenter || !idUserRol) {
            return { success: false, message: '' }
        }

        return await DLUpdateCenterUserFirstTime(idCenter, idUserRol, token)
    } catch (error) {
        await LogErrors('MarkFirstTimeEntry - Users BL', error)
        return { success: false, message: '' }
    }
}

export { MarkFirstTimeEntry };
